import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AlertComponent } from './alert.component';

const ANGULAR_MATERIAL_MODULES = [
  MatIconModule, MatButtonModule
];

const COMPONENTS = [
  AlertComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, ...ANGULAR_MATERIAL_MODULES],
  exports: [...COMPONENTS]
})
export class AlertModule { }
